// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import util from './util/util.js'

import axios from 'axios'
Vue.prototype.$axios = axios
import less from 'less'
Vue.use(less)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n);

Vue.prototype.$http = axios
Vue.prototype.$getUrl = util.getUrlVal
Vue.config.productionTip = false

var urlParam = function(name) {
    var href = window.location.href
    var hrefDecoded = decodeURIComponent(href)
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(hrefDecoded);
    return results == null ? null : results[1];
}


axios.interceptors.request.use(
    config => {
        let token = urlParam('accessToken');
        let locale = urlParam('locale')
        if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers['accessToken'] = token;
            config.headers['locale'] = locale;
            localStorage.setItem("accessToken", token);
            localStorage.setItem("locale", locale);
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

const lang = urlParam('locale')

if (lang == 'ar') {
    var link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = '../static/arstyle.css'; //css链接
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(link);
}

const i18n = new VueI18n({
    locale: lang, // 语言标识,
    messages: {
        'in': require('../localize/in.json'), // 英文语言包
        'en': require('../localize/en.json'), // 英文语言包
        'ar': require('../localize/ar.json'), // 英文语言包
    }
})


//window.http = 'https://api-test.funbit.me/funbit/v2/'; //测试地址
window.http = 'https://api.funbit.me/funbit/v2/' //线上地址

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    i18n,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js